( function( $ ) {
    $('#offCanvas').offcanvas({
      modifiers: 'right, overlay', // default options
      triggerButton: '#triggerButton' // btn to open offcanvas
    });
    
    var primary_nav_off_canvas = $('#offCanvas').data('offcanvas-component');
    
    $('#offcanvas--main-menu__close').on('click', function(e){
      e.preventDefault();
      primary_nav_off_canvas.close();
    });
  $(document).ready(function(){
    $('a.menu_search').each(function(e){
      $(this).addClass('is-closed');
    });
    $("a.menu_search").click(function(e){
      if($(this).hasClass('is-closed')) {
        $('.header__search__container').slideDown();
        $(this).removeClass('is-closed');
        $(this).addClass('is-open');
      }
      
      else {
        $('.header__search__container').slideUp();
        $(this).removeClass('is-open');
        $(this).addClass('is-closed');
      }
      
    });
    $("a.chevron_container").each(function(e){
      $(this).addClass('is-closed');
    });
    
    $("a.chevron_container").click(function(e){
      if($(this).hasClass('is-closed')) {
        $(this).siblings('.sub-menu').show();
        $(this).removeClass('is-closed');
        $(this).addClass('is-open');
        $(this).find('.fa').removeClass('fa-chevron-down');
        $(this).find('.fa').addClass('fa-chevron-up');
      }
      
      else {
        $(this).siblings('.sub-menu').hide();
        $(this).removeClass('is-open');
        $(this).addClass('is-closed');
        $(this).find('.fa').removeClass('fa-chevron-up');
        $(this).find('.fa').addClass('fa-chevron-down');
      }
      
    });
    
    $( ".rss_item .title a" ).each(function() {
      $(this).append('<span">...</span>');
    });
    $( ".rss_item .rss_content small a" ).each(function() {
      var new_text = '<span class="source">' + $(this).text() + '</span>'
      $(this).replaceWith(new_text);
    });
    $('.feedzy-rss ul').slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow: '<li><i class="fa fa-chevron-left" aria-hidden="true"></i><span class="element-invisible">Previous</span></li>',
        nextArrow: '<li><i class="fa fa-chevron-right" aria-hidden="true"></i><span class="element-invisible">Next</span></li>',
        appendArrows: '.nh_rss_nav',
    });
    
    $('.nh_carousel').slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        //centerMode: true,
        variableWidth: true,
        prevArrow: '<li><i class="fa fa-chevron-left" aria-hidden="true"></i><span class="element-invisible">Previous</span></li>',
        nextArrow: '<li><i class="fa fa-chevron-right" aria-hidden="true"></i><span class="element-invisible">Next</span></li>',
        appendArrows: '.nh_carousel_nav',
    });
    
    $('.nh_initiatives_container').slick({
        slidesToShow: 1,
        infinite: true,
        autoplaySpeed: 5000,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        prevArrow: '<li><i class="fa fa-chevron-left" aria-hidden="true"></i><span class="element-invisible">Previous</span></li>',
        nextArrow: '<li><i class="fa fa-chevron-right" aria-hidden="true"></i><span class="element-invisible">Next</span></li>',
        appendArrows: '.nh_initiatives_nav',
        adaptiveHeight: false,
    });
    
    function tabbyThings(){
        $('.tab_bar .tab_item_button:first-of-type').removeClass('is-closed').addClass('is-open');
        $('.tab_bar .tab_item_button:first-of-type').attr("aria-selected","true");
        $('.tab_bar .tab_item_button:first-of-type').attr("tabindex","0");
    
        $('.tab_item_button').click(function(e){
            $('.tab_bar .tab_item_button').removeClass('is-open').addClass('is-closed');
            $('.tab_bar .tab_item_button').attr("aria-selected","false");
            $('.tab_bar .tab_item_button').attr("tabindex","-1");
            e.preventDefault();
            $('.tab_item').hide();
            var target = '#tab_id_'+$(this).attr('data-tab-id');
    
            if($(this).hasClass('is-open')){
                $(this).addClass('is-closed').removeClass('is-open');
                $(this).attr("aria-selected","false");
                $(this).attr("tabindex","-1");
                $(target).fadeOut();
            }
    
            if($(this).hasClass('is-closed')){
                $(this).addClass('is-open').removeClass('is-closed');
                $(this).attr("aria-selected","true");
                $(this).attr("tabindex","0");
                $(target).fadeIn();
            }
        });
    };
    
    tabbyThings();
  });
} )( jQuery );
